export const ITEM_TYPE = "FIELD";
export const BOARD_TYPE = "BOARD";